<script>
import FormModal from '../../../../components/modals/FormModal.vue';
import axios from "axios";

export default {
    components: { FormModal },
    props: {
        isShow: {
            type: Boolean,
            required: true,
            default: false
        },
        showModal: {
            type: Function,
            required: true
        },
        onBoardingChecklistItems: {
            type: Array,
            required: true
        },
        reloadPage: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            modalShow: false,
            isButtonLoading: false,
            submitButtonText: "Save Changes",
            selectedItems: []
        }
    },
    watch: {
        isShow() {
            this.modalShow = this.isShow
        }
    },
    methods: {
        onBoardingChecklistSubmit() {
            this.submitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`;
            this.isButtonLoading = true;
            axios
            .post(route("update-onboarding-checklist-items"), { items: this.selectedItems }, {})
            .then((response) => {
                this.reloadPage();
                this.$toastr.s(response.data.message);
                this.submitButtonText = 'Save Changes';
                this.isButtonLoading = false;
                this.hideModal();
            })
            .catch((err) => {
                this.$toastr.e(err.response.data.message);
                this.submitButtonText = 'Save Changes';
                this.isButtonLoading = false;
            });
        },
        hideModal() {
            this.showModal(false, []);
            this.submitButtonText = 'Save Changes';
            this.isButtonLoading = false;
        },
        updateCompletionStatus(item, isChecked) {
            // Find the index of the item in the selectedItems array
            const index = this.selectedItems.findIndex((selectedItem) => selectedItem.id === item.id);

            if (isChecked) {
                if (index === -1) {
                    this.selectedItems = [...this.selectedItems, {id: item.id, is_completed: 1}];
                }
                else {
                    this.selectedItems[index].is_completed = 1;
                }
            } else {
                if (index === -1) {
                    this.selectedItems = [...this.selectedItems, {id: item.id, is_completed: 0}];
                }
                else {
                    this.selectedItems[index].is_completed = 0;
                }
            }
        }
    }
}
</script>

<template>
    <FormModal
        :isShow="modalShow"
        title="Onboarding Checklist"
        :isButtonLoading="isButtonLoading"
        :isShowSubmitButton="true"
        :clickSubmitButton="onBoardingChecklistSubmit"
        :submitButtonText="submitButtonText"
        modalSize="md"
        :isShowCancelButton="true"
        @hideModal="hideModal"
        :noClose="false"
    >   
        <div v-for="(item, index) in onBoardingChecklistItems" class="d-flex ms-3 gap-2" :key="index">
            <input
                role="button" 
                type="checkbox" 
                @change="updateCompletionStatus(item, $event.target.checked)"
                :checked="item.is_completed"
            />
            <span>{{ item.title }}</span>
        </div>
    </FormModal>
</template>